export default "__VITE_ASSET__nLN49prY__"